import { TerminalGateFrom, TerminalGateTo } from "./TerminalGate";

export const CheckTerminal = (terminal: string, fromAirport: boolean) => {
  var address: string = terminal;

  if (fromAirport) {
    TerminalGateFrom.find((items) => {
      if (items.id === terminal) {
        address = items.name;
      }
    });
  } else {
    TerminalGateTo.find((items) => {
      if (items.id === terminal) {
        address = items.name;
      }
    });
  }
  return address;
};
